import { externalLink } from "@/routes/_constants/external-link";

import { ExternalLink } from "@/components/ui/button/external-link";

/**
 * CHILLNN サポート「決済」（ゲスト向け FAQ）
 * https://support.chillnn.com/faq/guest/payment/
 *
 * ゲストからオーソリ・デビットカードの引き落としについて問い合わせを受けた施設が、案内に使えるようにする。
 * ベースURLは externalLink.faqSite（dev/prd で自動切替）を使う。
 */
const PAYMENT_FAQ_URL = `${externalLink.faqSite}/faq/guest/payment/`;

/**
 * 決済に関するよくあるお問い合わせへのリンク
 * ゲスト向けの決済 FAQ は現地決済のキャンセル料や領収書も扱うため、決済方法・予約の状態にかかわらず表示する
 */
export const PaymentFaqLinkOfManagementStatusCompositions = () => {
	return <ExternalLink href={PAYMENT_FAQ_URL} text="決済に関するよくあるお問い合わせ" className="h-auto text-sm" />;
};
